module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dB14K"))).then(() => parcelRequire('dJXJK'));